import { render, staticRenderFns } from "./browser-judge.vue?vue&type=template&id=54ca09ff&scoped=true&"
import script from "./browser-judge.vue?vue&type=script&lang=js&"
export * from "./browser-judge.vue?vue&type=script&lang=js&"
import style0 from "./browser-judge.vue?vue&type=style&index=0&id=54ca09ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ca09ff",
  null
  
)

export default component.exports